export function toCamelCase(str = ""): string {
  const words = str
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .toLowerCase()
    .split(" ")

  const camelCaseWords = words.map((word, index) => {
    if (index === 0) {
      return word
    } else {
      return word.charAt(0).toUpperCase() + word.substring(1)
    }
  })

  return camelCaseWords.join("")
}

export const getValueInDbFormat = (columnName: string) => {
  switch (columnName) {
    case "duration":
      return "duration"
    case "realdate":
      return "realDate"
    case "realprogram":
      return "realProgram"
    case "realduration":
      return "realDuration"
    case "realmediacost":
      return "realMediaCost"
    case "program":
      return "program"
    case "status":
      return "status"
    case "date":
      return "date"
    case "vendorproduct":
      return "supplierProduct"
    case "copy":
      return "copyName"
    case "startdate":
      return "startDate"
    case "enddate":
      return "endDate"
    case "billingtype":
      return "billingType"
    case "timebelt":
      return "timebelt"
    case "realtime":
      return "realTime"
    case "realgrpa":
      return "realGRPsA"
    case "realweightedgrpa":
      return "realWeightedGRPsA"
    case "realgrpb":
      return "realGRPsB"
    case "breaknumber":
      return "breakNumber"
    case "numberofspotsinbreak":
      return "numberOfSpotsInBreak"
    case "spotpositioninbreak":
      return "spotPositionInBreak"
    case "submediatype":
      return "subMediaType"
    case "toleranceused":
      return "matchingTimeTolerance"
    case "programendtime":
      return "programEndTime"
    case "programstarttime":
      return "programStartTime"
    case "bonumber":
      return "bookingOrderNumber"
    case "matchtype":
      return "matchType"
    default:
      return columnName
  }
}
